// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2OUEH","label":"Section_label__qDRPY","contentWrap":"Section_contentWrap__SKG16","footer":"Section_footer__1jaE8","footerInner":"Section_footerInner__1zjRF"};